import { Component, OnInit, Inject, ViewChild } from "@angular/core";
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from "@angular/material";
import { PhoneNumberInputComponent } from "../../components/phoneNumberInput/phoneNumberInput.component";

@Component({
  selector: "notificateViaSMSDialog",
  templateUrl: "./notificateViaSMSDialog.component.html",
  styleUrls: ["./notificateViaSMSDialog.component.scss"]
})

export class NotificateViaSMSDialogComponent implements OnInit {
  @ViewChild("phoneNumberInput") phoneNumberInput: PhoneNumberInputComponent;

  constructor(public bottomSheetRef: MatBottomSheetRef<NotificateViaSMSDialogComponent, string>
    , @Inject(MAT_BOTTOM_SHEET_DATA) public isInHouseGroupOrder: boolean) { }


  ngOnInit() {
  }

  public setNotification() {
    const me = this;
    let phoneNumber: string = me.phoneNumberInput.PhoneNumber;
    me.bottomSheetRef.dismiss(phoneNumber);
  }

  public discardToMenuGroup() {
    const me = this;
    me.bottomSheetRef.dismiss("");
  }
}
